import {
  BaseEntityDTO,
  IBaseEntityDTO,
  IProductVariantDTO,
  ITeamLevelDTO,
  TeamLevelDTO,
  IYearDTO,
  YearDTO,
  ProductVariantDTO,
} from './';

export interface IProductDTO extends IBaseEntityDTO {
  title: string;
  teamLevel?: ITeamLevelDTO;
  variants: IProductVariantDTO[];
  year?: IYearDTO;
}

export class ProductDTO extends BaseEntityDTO implements IProductDTO {
  title: string;
  teamLevel?: ITeamLevelDTO;
  variants: IProductVariantDTO[];
  year?: IYearDTO;

  constructor(data?: Partial<ProductDTO>) {
    super(data);
    this.title = data?.title ?? '';
    this.teamLevel = new TeamLevelDTO(data?.teamLevel);
    this.variants = data?.variants
      ? data.variants.map((variant) => new ProductVariantDTO(variant))
      : [];
    this.year = data?.year ? new YearDTO(data.year) : new YearDTO();
  }
}
